import { useState } from 'react'
import AdminAppSidebar from './AdminAppSidebar'
import AdminAppTopbar from './AdminAppTopbar'

export default function AdminAppLayout({ children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const closeMobileMenu = () => setMobileMenuOpen(false)
  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev)

  return (
    <div className="h-screen flex overflow-hidden bg-[#0f1623] text-[#e8edf5]">
      <div className="hidden lg:flex lg:shrink-0">
        <AdminAppSidebar />
      </div>

      {mobileMenuOpen ? (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/60" onClick={closeMobileMenu} />
          <div className="relative h-full w-[230px]">
            <AdminAppSidebar onNavigate={closeMobileMenu} />
          </div>
        </div>
      ) : null}

      <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
        <AdminAppTopbar onMenuToggle={toggleMobileMenu} />

        <main className="flex-1 overflow-y-auto bg-[#0f1623] px-4 py-4 lg:px-6 lg:py-6">
          {children}
        </main>
      </div>
    </div>
  )
}
